export const GOOGLE_MAPS_API_KEY = 'AIzaSyDuKd06-mvuRlSKiR3-8xA9P1XVOymgk_w';
